import * as React from 'react';
import { Svg, Circle, Path } from 'react-native-svg';
import { memo } from 'react';
import type { IconProps } from '../helpers/icon-props';

const Icon = (props: IconProps) => {
  const { size = 24, ...otherProps } = props;
  return (
    <Svg width={size} height={size} viewBox="0 0 512 512" {...otherProps}>
      <Circle cx={256} cy={256} r={256} fill="#f0f0f0" />
      <Path d="M0 256c0 141.384 114.616 256 256 256V256z" fill="#0052b4" />
      <Path d="M256 0c141.384 0 256 114.616 256 256H256z" fill="#d80027" />
      <Path
        d="m152.389 89.043 16.577 51.018h53.643l-43.398 31.53 16.576 51.018-43.398-31.531-43.398 31.531 16.576-51.018-43.398-31.53h53.643z"
        fill="#0052b4"
      />
      <Path
        d="m359.611 289.391 16.577 51.018h53.643l-43.399 31.53 16.577 51.018-43.398-31.531-43.398 31.531 16.576-51.018-43.398-31.53h53.643z"
        fill="#d80027"
      />
    </Svg>
  );
};
Icon.displayName = 'Panama';
export const Panama = memo<IconProps>(Icon);
